import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorsMordoviaForecast.try: {
            return true;
        }

        case constants.getCalculatorsMordoviaForecast.success:
        case constants.getCalculatorsMordoviaForecast.error: {
            return false;
        }

        default:
            return state;
    }
}